import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_MOVIMIENTOS_EXPORTADOR } from '../../../../config/tables'

function TotalMovimientoExportadoresView () {
  return (
    <MuiTable id={TABLA_MOVIMIENTOS_EXPORTADOR} />
  )
}

export default TotalMovimientoExportadoresView
